// src/pages/FileFormOnline.js
import React, { useEffect } from "react";
import DashboardHeader from "../../components/headers/DashboardHeader";
import { Link, useNavigate } from "react-router-dom";
import { Box, Card, CardContent } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

const FileFormOnline = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("code-verified")) {
      navigate("/login", { replace: true });
    }
  }, []);

  return (
    <div className="">
      <DashboardHeader />
      <div className="dashboard-content">
        <div className="form-filing-container">
          <h2 className="mb-2">Completing Your Form Online</h2>

          <Card
            sx={{
              mt: 4,
              mb: 2,
              bgcolor: "#fff",
              borderLeft: "15px solid #c10000",
              boxShadow: 1,
            }}
          >
            <CardContent
              sx={{ display: "flex", alignItems: "flex-start", p: 2 }}
            >
              <InfoIcon
                sx={{ color: "#c10000", fontSize: 24, mt: 0.5, mr: 2 }}
              />
              <Box sx={{ color: "#333", fontSize: 14 }}>
                <h4>Filing online</h4>
                <p>
                  Submitting your form online is the same as mailing in a
                  completed paper form. They both gather the same information.
                </p>
              </Box>
            </CardContent>
          </Card>

          <Card
            sx={{
              mt: 2,
              mb: 2,
              bgcolor: "#fff",
              borderLeft: "15px solid #c10000",
              boxShadow: 1,
            }}
          >
            <CardContent
              sx={{ display: "flex", alignItems: "flex-start", p: 2 }}
            >
              <InfoIcon
                sx={{ color: "#c10000", fontSize: 24, mt: 0.5, mr: 2 }}
              />
              <Box sx={{ color: "#333", fontSize: 14 }}>
                <h4>Complete the Getting Started section first</h4>

                <p>
                  You should answer all questions in the Getting Started section
                  first so we can best customize the rest of your online form
                  experience.
                </p>
              </Box>
            </CardContent>
          </Card>

          <div>
            <Card
              sx={{
                mt: 2,
                mb: 2,
                bgcolor: "#fff",
                borderLeft: "15px solid #c10000",
                boxShadow: 1,
              }}
            >
              <CardContent
                sx={{ display: "flex", alignItems: "flex-start", p: 2 }}
              >
                <InfoIcon
                  sx={{ color: "#c10000", fontSize: 24, mt: 0.5, mr: 2 }}
                />
                <Box sx={{ color: "#333", fontSize: 14 }}>
                  <h4>Provide as many responses as you can</h4>
                  <p>
                    You should provide as many responses as you can. Incomplete
                    fields or sections and missing information can slow down the
                    process after you submit your form.
                  </p>
                </Box>
              </CardContent>
            </Card>

            <div className="">
              <div>
                <Card
                  sx={{
                    mt: 2,
                    mb: 2,
                    bgcolor: "#fff",
                    borderLeft: "15px solid #c10000",
                    boxShadow: 1,
                  }}
                >
                  <CardContent
                    sx={{ display: "flex", alignItems: "flex-start", p: 2 }}
                  >
                    <InfoIcon
                      sx={{ color: "#c10000", fontSize: 24, mt: 0.5, mr: 2 }}
                    />
                    <Box sx={{ color: "#333", fontSize: 14 }}>
                      <h4>We will automatically save your responses</h4>
                      <p>
                        We will automatically save your information when you
                        select next to go to a new page or navigate to another
                        section of the form. We will save your information for
                        30 days from today, or from the last time you worked on
                        the form.
                      </p>
                    </Box>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>

          {/* Added OMB Information Section */}

          {/* Added Security Reminder */}
          <div className="">
            <Card
              sx={{
                mt: 2,
                mb: 2,
                bgcolor: "#fff",
                borderLeft: "15px solid #c10000",
                boxShadow: 1,
              }}
            >
              <CardContent
                sx={{ display: "flex", alignItems: "flex-start", p: 2 }}
              >
                <InfoIcon
                  sx={{ color: "#c10000", fontSize: 24, mt: 0.5, mr: 2 }}
                />
                <Box sx={{ color: "#333", fontSize: 14 }}>
                  <h4>Security Reminder</h4>

                  <p>
                    If you do not work on your application for more than 30
                    days, we will delete your data in order to prevent storing
                    personal information indefinitely.
                  </p>
                </Box>
              </CardContent>
            </Card>
          </div>

          <div className="form-navigation">
            <button
              className="secondary-button"
              onClick={() => navigate("/dashboard")}
            >
              Back
            </button>
            <button
              className="primary-button"
              onClick={() => navigate("/visa/getting_started")}
            >
              Start
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileFormOnline;
